import { render, staticRenderFns } from "./RotaList.vue?vue&type=template&id=03627ba3&scoped=true"
import script from "./RotaList.vue?vue&type=script&lang=js"
export * from "./RotaList.vue?vue&type=script&lang=js"
import style0 from "./RotaList.vue?vue&type=style&index=0&id=03627ba3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03627ba3",
  null
  
)

export default component.exports